import { useQuery } from "@tanstack/react-query";
import { getSalesStopData } from "../services/articles.service";
import { QueryKeys } from "./queryKeys";

export const useSalesStopData = (storeId: string, articleNumbers: string) => {
  return useQuery({
    queryKey: [QueryKeys.SalesStopData, storeId, articleNumbers],
    queryFn: () => getSalesStopData(storeId, articleNumbers),
    enabled: !!storeId && !!articleNumbers,
    gcTime: 1000 * 60 * 60 * 24, // 24 hours cache time
    staleTime: 1000 * 60 * 60 * 24, // 24 hours stale time
  });
};
